var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1022_902)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1022_902)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99943 2.62224C5.30526 2.62224 2.31055 5.61695 2.31055 9.31112C2.31055 13.0053 5.30526 16 8.99943 16C12.6936 16 15.6883 13.0053 15.6883 9.31112C15.6883 5.61695 12.6936 2.62224 8.99943 2.62224Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.24651 2.83109C5.44777 2.67008 5.4804 2.37641 5.31939 2.17516C5.15839 1.9739 4.86472 1.94127 4.66346 2.10228L3.10791 3.34672C2.90665 3.50773 2.87403 3.80139 3.03503 4.00265C3.19603 4.20391 3.4897 4.23654 3.69096 4.07553L5.24651 2.83109Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3354 2.10228C13.1341 1.94127 12.8405 1.9739 12.6795 2.17516C12.5185 2.37641 12.5511 2.67008 12.7523 2.83109L14.3079 4.07553C14.5091 4.23654 14.8028 4.20391 14.9638 4.00265C15.1248 3.80139 15.0922 3.50773 14.8909 3.34672L13.3354 2.10228Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1022_902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.46586 6.82232C9.46586 6.56459 9.25693 6.35565 8.9992 6.35565C8.74147 6.35565 8.53253 6.56459 8.53253 6.82232V9.43928C8.53253 9.63764 8.45674 9.82851 8.32067 9.97284L7.4152 10.9332C7.2384 11.1208 7.24709 11.4161 7.43462 11.5929C7.62215 11.7697 7.9175 11.761 8.0943 11.5735L8.99977 10.6131C9.29913 10.2956 9.46586 9.87567 9.46586 9.43928V6.82232Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1022_902",
    x: -21.6895,
    y: -22,
    width: 61.3779,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1022_902"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1022_902",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1022_902",
    x: 4.28809,
    y: 3.35565,
    width: 18.1777,
    height: 21.3644,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.176471 0 0 0 0 0.556863 0 0 0 0 0.678431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1022_902"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1022_902",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1022_902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.d8e9e21ef417dace956f730843fc7f88.svg";
export { ForwardRef as ReactComponent };